import { TonApiClient } from '@ton-api/client'
import { useEffect, useState } from 'react'
import { useTonConnect } from './useTonConnect'
import { isMainnet } from '../shared/utils/network'

export const useInitializeTonApiClient = () => {
  const { network } = useTonConnect()
  const [tonApiClient, setTonApiClient] = useState<TonApiClient | null>(null)

  useEffect(() => {
    const tonApiClient = new TonApiClient({
      baseUrl: isMainnet(network)
        ? 'https://tonapi.io'
        : 'https://testnet.tonapi.io',
    })

    setTonApiClient(tonApiClient)
  }, [network])

  return tonApiClient
}
